import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { GutHealthSection } from './components/GutHealthSection';
import { SymptomsSection } from './components/SymptomsSection';
import { ProductSection } from './components/ProductSection';
import { ResultsSection } from './components/ResultsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ReviewsSection } from './components/ReviewsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { DosageSection } from './components/DosageSection';
import { MalnutritionSection } from './components/MalnutritionSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full bg-amber-50" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <GutHealthSection data-id="element-5" />
        <SymptomsSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <ResultsSection data-id="element-8" />
        <ComparisonSection data-id="element-9" />
        <ReviewsSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <DosageSection data-id="element-12" />
        <MalnutritionSection data-id="element-13" />
        <CTASection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}